<div class="wrapper" [ngClass]="{'success': success, 'error': error}" *ngIf="isOpen" [@dropDown]>
  <img class="icon-arrow-in-circle" *ngIf="success">
  <img class="icon-error" *ngIf="error">
  <div class="text-box">
    <p class="title">{{title}}</p>
    <p *ngIf="description" class="description">{{description}}</p>
    <div class="button-box" *ngIf="buttonText">
      <app-main-button
        (onClick)="onButtonClick($event)"
        [fontSize]="'12px'"
        [buttonHeight]="'28px'"
        [buttonWidth]="'148px'"
        [border]="'1px solid #FFFFFF'"
        [textColor]="'#FFFFFF'"
        [backgroundColor]="'transparent'"
        [buttonText]="buttonText">
      </app-main-button>
    </div>
  </div>
  <img class="icon-cross-white" (click)="onCloseClick()">
</div>
